import * as tslib_1 from "tslib";
import React from 'react';
import invariant from 'invariant';
import assign from 'lodash.assign';
import { componentMap } from '@/shared/PageConfig';
export default function createElement(eles, state) {
    return eles
        .map((ele) => {
        let childrenArray = [];
        const props = ele.props || {};
        // tslint:disable-next-line
        let { children } = props, othersProps = tslib_1.__rest(props, ["children"]);
        const { transform } = ele;
        if (transform) {
            const transformProps = transform(state);
            if (!transformProps) {
                // 父级不存在，，子级不需要在执行
                return null;
            }
            othersProps = assign(othersProps, transformProps);
        }
        if (children) {
            childrenArray = createElement(children, state);
        }
        const targetCompeont = componentMap[ele.component];
        invariant(targetCompeont, 'config unit must have component attr,but %s not', ele.component);
        return React.createElement(targetCompeont, othersProps, childrenArray);
    })
        .filter(Boolean);
}
